import none from '../../img/leoLogo.png'
import  chikenstake  from "../../img/pizza/chikenstake.jpg"
import  mitbal  from "../../img/pizza/mitbal.jpg"
import  peperoni  from "../../img/pizza/peperoni.jpg"

export const italiaPizza=[
    {
      "id": "251",
      "title": "میت بال",
      "desciption": "گوشت توپی پنیر موزرلا سس هالندیز پیاز حلقه ای گوجه گیلاسی ریحان ایتالیایی پنیر پارمسان",
      "price": "450",
      "image": mitbal
    },
    {
      "id": "252",
      "title": "پیتزا سیر و استیک",
      "desciption": "راسته گوساله طعم دار شده پنیر موزرلا سس مارینارا + سیر  زیتون سبزی رکولا",
      "price": "460",
      "image": none
    },
    {
      "id": "253",
      "title": "پیتزا شف",
      "desciption": "راسته گوساله طعم دار شدت سس مارینارا پنیرموزرلا چوریتسو بیکن گوجه گیلاسی پیاز حلقه ای قارچ زیتون",
      "price": "465",
      "image": none
    },
    {
      "id": "254",
      "title": "پیتزا چیکن استیک",
      "desciption": "استیک مرغ گیریل شده  سس مارینار قارچ پیاز حلقه ای گوجه ای پنیر موزرلا سبزی جعفری",
      "price": "405",
      "image": chikenstake
    },
    {
      "id": "255",
      "title": "پیتزا پپرونی",
      "desciption": "کالباس پپرونی هالوپینو پنیر پنیر موزرلا سس مارینارا پوره هالوپینو",
      "price": "389",
      "image": peperoni
    },
    {
      "id": "256",
      "title": "پیتزا سبزی جات",
      "desciption": "پنیز موزرالا سس مارینارا کدو‌بادمجان کلم بروکلی قارچ گوجه گیلاسی زیتون پیاز حلقه ای فلفل دلمه ای",
      "price": "350",
      "image": none
    },
    {
      "id": "257",
      "title": "پیتزا مارگاریتا",
      "desciption": "پنیر موزرلا سس مارینارا گوجه گیلاسی ریحون ایتالیایی",
      "price": "375",
      "image": none
    },
    
  ]